import { render, staticRenderFns } from "./file.vue?vue&type=template&id=79b3c4cb&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style0 from "./file.vue?vue&type=style&index=0&id=79b3c4cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b3c4cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79b3c4cb')) {
      api.createRecord('79b3c4cb', component.options)
    } else {
      api.reload('79b3c4cb', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=79b3c4cb&scoped=true", function () {
      api.rerender('79b3c4cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/file.vue"
export default component.exports